import { NavigationItem } from '@models';
import { environment } from '../environments/environment';

export const NavigationConfig: NavigationItem[] = [
  { label: 'Dashboard', route: 'dashboard', icon: 'chart-mixed' },
  { label: 'Patient list', route: 'patient-list', icon: 'users-group' },
  { label: 'Forms', route: 'forms', icon: 'clipboard-list' },
  { label: 'Meetings', route: 'meetings', icon: 'calendar-month' },
  { label: 'Chats', route: 'chats', icon: 'messages' },
  { label: 'Fax', route: 'fax', icon: 'printer-outline' },
  ...(environment.voicemailUiEnabled
    ? [{ label: 'Calls & voicemails', route: 'calls', icon: 'phone-outline' }]
    : []),
  { label: 'Billing', route: 'billing', icon: 'wallet' },
  { label: 'Education', route: 'education', icon: 'education' },
  { label: 'Programs', route: 'programs', icon: 'book' },
];

export const CareToolsConfig: NavigationItem[] = [
  { label: 'Protocols', route: 'protocols', icon: 'clipboard-list' },
  { label: 'Drug-Herb', route: 'drug-herb', icon: 'drug-herb' },
  // Opens the cross-patient AI Lab list. The patient search that used to live behind this
  // item is the "Find patient" control on that page; the dashboard "Go to AI Lab" quick
  // action still jumps straight to one patient's analyses.
  { label: 'AI Lab', route: 'ai-lab', icon: 'flask-conical-outline' },
];

export const GrowthConfig: NavigationItem[] = [
  { label: 'Provider Website', route: 'provider-website', icon: 'globe' },
  { label: 'Marketing', route: 'marketing-embed', icon: 'megaphone' },
  { label: 'New Leads', route: 'new-leads', icon: 'user-plus' },
];

export const ProvidersSetupsConfig: NavigationItem[] = [
  { label: 'Form templates', route: 'form-templates', icon: 'document-text' },
  { label: 'Settings', route: 'settings', icon: 'cog' },
];
